module.exports = __webpack_public_path__ + "static/img/dd@3x.ae213329.png";